/* this file is transformed by vux-loader */
/* eslint-disable */
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
import { login as _login } from '@/api/login';
import UBT from '@/utils/ubt';
import Storage from '@/utils/storage';
var loginResultCache = JSON.parse(Storage.getItem('login-result') || JSON.stringify({
  token: '',
  ticket: '',
  expire: '',
  userNewId: '',
  promotionUserId: '',
  userName: '',
  ruleType: '',
  activityId: '',
  mobile: ''
}));
UBT.bindUserInfo(loginResultCache);
var user = {
  state: {
    loginResult: loginResultCache,
    webviewToken: '',
    tianqiParams: {}
  },
  mutations: {
    SET_LOGIN_RESULT: function SET_LOGIN_RESULT(state, loginResult) {
      state.loginResult = loginResult;
      UBT.bindUserInfo(loginResult);
      Storage.setItem('login-result', JSON.stringify(loginResult), new Date(Date.now() + loginResult.expire * 1000));
    },
    SET_WEBVIEW_TOKEN: function SET_WEBVIEW_TOKEN(state, token) {
      state.webviewToken = token;
    },
    SET_TQ_PARAMS: function SET_TQ_PARAMS(state, params) {
      Object.assign(state.tianqiParams, params);
    },
    LOGOUT: function LOGOUT(state) {
      state.loginResult = {
        token: '',
        ticket: '',
        expire: '',
        userNewId: '',
        promotionUserId: '',
        userName: '',
        ruleType: '',
        activityId: '',
        mobile: ''
      };
      Storage.removeItem('login-result');
    }
  },
  actions: {
    // 登录
    login: function login(_ref, loginParams) {
      var commit = _ref.commit;
      return _login(loginParams).then(function (data) {
        commit('SET_LOGIN_RESULT', data);
        return data;
      });
    },
    logout: function logout(_ref2) {
      var commit = _ref2.commit;
      commit('LOGOUT');
    }
  }
};
export default user;